"use strict";
angular.module('departmentManuCommonServiceModule', [
    'createCompanyManuModule',
    'createDepartmentManuModule'
]).factory('departmentManuCommonService',
    ["trsHttpService", "$modal", "$q", function(trsHttpService,$modal,$q) {
    return {
        /**
         * [createNewReport description] 新建或编辑单位
         * @param  {[type]} id  [description]
         * @param  {[type]} type [description]
         * @return {[type]}          [description]
         */
        createCompanyManu:function(item,type,success){
            var defer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/departmenManusManageMent/service/createCompanyManu/main_tpl.html",
                windowClass: "createCompanyManuC",
                backdrop: false,
                controller: "createCompanyManuController",
                resolve: {
                    transParams: function() {
                        return {
                            "item": item,
                            "type":type
                        };
                    }
                }
            });
            modalInstance.result.then(function(result) {
                defer.resolve("success");
            }, function() {
                defer.reject("cancle");
            });
            return defer.promise;
        },
        /**
         * [createNewReport description] 新建或编辑部门
         * @param  {[type]} id  [description]
         * @param  {[type]} type [description]
         * @return {[type]}          [description]
         */
         createDepartmentManu:function(item,type){
            var defer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/departmenManusManageMent/service/createDepartmentManu/main_tpl.html",
                windowClass: "createDepartmentManuC",
                backdrop: false,
                controller: "createDepartmentManuController",
                resolve: {
                    transParams: function() {
                        return {
                            "item": item,
                            "type":type
                        };
                    }
                }
            });
            modalInstance.result.then(function(result) {
                defer.resolve("success");
            }, function() {
                defer.reject("cancle");
            });
            return defer.promise;
        },
    };
}]);
